(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    (function () {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    var cfg = {};
    try { cfg = JSON.parse(drawer.querySelector('[data-drawer-config]').textContent); } catch (e) { return; }
    var i18n = cfg.i18n || {};
    var moneyFormat = cfg.moneyFormat || ('$' + String.fromCharCode(123, 123) + 'amount' + String.fromCharCode(125, 125));
    var activeCurrency = cfg.activeCurrency;
    var threshold = parseInt(drawer.getAttribute('data-threshold'), 10) || 0;
    var addonVariant = drawer.getAttribute('data-addon-variant');

    // Cart AJAX amounts are already in the active presentment currency; format with its
    // ISO code (from /cart.js `currency`) so the symbol is correct under Shopify Markets.
    function money(cents, code) {
      code = code || activeCurrency;
      if (code) { try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: code }).format(cents / 100); } catch (e) {} }
      var value = (cents / 100).toFixed(2);
      if (moneyFormat.indexOf('amount_no_decimals') !== -1) value = Math.round(cents / 100).toString();
      return moneyFormat.replace(/\{\{\s*amount(_no_decimals)?\s*\}\}/g, value);
    }
    function open() { drawer.hidden = false; document.body.style.overflow = 'hidden'; refresh(); }
    function close() { drawer.hidden = true; document.body.style.overflow = ''; }

    document.querySelectorAll('[data-cart-open]').forEach(function (b) { b.addEventListener('click', open); });
    drawer.querySelectorAll('[data-cart-close]').forEach(function (b) { b.addEventListener('click', close); });

    function updateShip(cart) {
      var ship = drawer.querySelector('[data-ship]');
      if (!ship || threshold <= 0) return;
      var fill = ship.querySelector('[data-ship-fill]');
      var text = ship.querySelector('[data-ship-text]');
      // Threshold is in shop base units; convert to the active currency when a market rate is set.
      var thr = threshold;
      if (window.Shopify && Shopify.currency && Shopify.currency.rate) { thr = threshold * (parseFloat(Shopify.currency.rate) || 1); }
      var pct = Math.min(100, (cart.total_price / thr) * 100);
      fill.style.width = pct + '%';
      if (cart.total_price >= thr) {
        text.innerHTML = i18n.unlocked || '';
      } else {
        text.innerHTML = (i18n.progress || '').replace('__AMT__', '<b>' + money(thr - cart.total_price, cart.currency) + '</b>');
      }
    }

    function renderItems(cart) {
      var body = drawer.querySelector('[data-drawer-body]');
      if (!cart.items.length) {
        body.innerHTML = '<p class="mie-drawer__empty">' + (i18n.empty || '') + '</p>';
      } else {
        body.innerHTML = cart.items.map(function (it) {
          var priceHtml = (it.original_line_price > it.final_line_price ? '<s>' + money(it.original_line_price, cart.currency) + '</s> ' : '') + '<b>' + money(it.final_line_price, cart.currency) + '</b>';
          var variant = it.options_with_values ? it.options_with_values.map(function (o) { return o.value; }).join(' · ') : '';
          return '<div class="mie-line" data-key="' + it.key + '">' +
            '<img class="mie-line__img" src="' + (it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_120x120$1$2') : '') + '" alt="" width="64" height="64" loading="lazy">' +
            '<div><p class="mie-line__name">' + it.product_title + '</p>' +
            (variant && variant !== 'Default Title' ? '<p class="mie-line__variant">' + variant + '</p>' : '') +
            '<p class="mie-line__price">' + priceHtml + '</p></div>' +
            '<div class="mie-line__qty"><button type="button" data-dec aria-label="minus">&ndash;</button><span>' + it.quantity + '</span><button type="button" data-inc aria-label="plus">+</button></div>' +
            '</div>';
        }).join('');
        body.querySelectorAll('.mie-line').forEach(function (line) {
          var key = line.getAttribute('data-key');
          var item = cart.items.filter(function (i) { return i.key === key; })[0];
          line.querySelector('[data-dec]').addEventListener('click', function () { change(key, item.quantity - 1); });
          line.querySelector('[data-inc]').addEventListener('click', function () { change(key, item.quantity + 1); });
        });
      }
      drawer.querySelectorAll('[data-drawer-count],[data-drawer-itemcount]').forEach(function (el) { el.textContent = cart.item_count; });
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = cart.item_count;
        el.classList.toggle('is-empty', cart.item_count === 0);
      });
      var sub = drawer.querySelector('[data-drawer-subtotal]');
      if (sub) {
        sub.innerHTML = (cart.original_total_price > cart.total_price ? '<s>' + money(cart.original_total_price, cart.currency) + '</s> ' : '') +
          '<b>' + money(cart.total_price, cart.currency) + '</b>' +
          (cart.total_discount > 0 ? '<span class="mie-drawer__off">' + money(cart.total_discount, cart.currency) + ' ' + (i18n.off || '') + '</span>' : '');
      }
      updateShip(cart);
    }

    function refresh() { fetch(cfg.cartUrl + '.js').then(function (r) { return r.json(); }).then(renderItems); }
    function change(key, qty) {
      fetch(cfg.changeUrl + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: Math.max(0, qty) })
      }).then(function (r) { return r.json(); }).then(renderItems);
    }
    function addItems(items) {
      items = (items || []).filter(function (it) { return it && it.id; });
      if (!items.length) return Promise.resolve();
      return fetch(cfg.addUrl + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) { return r.json(); }).then(function () { open(); });
    }
    function add(variantId, qty) { return addItems([{ id: variantId, quantity: qty || 1 }]); }

    // Expose the drawer controls globally AND via a document event as early as
    // possible — before the listener wiring below — so an error further down can
    // never leave the rest of the theme unable to add to / open the drawer.
    window.mieCartOpen = open;
    window.mieCartAdd = add;
    window.mieCartAddItems = addItems;
    window.mieCartRefresh = refresh;
    document.addEventListener('mie:cart:open', function () { open(); });

    drawer.querySelectorAll('[data-add-variant]').forEach(function (b) {
      b.addEventListener('click', function () { add(b.getAttribute('data-add-variant'), 1); });
    });
    var addonToggle = drawer.querySelector('[data-addon-toggle]');
    if (addonToggle && addonVariant) {
      addonToggle.addEventListener('change', function () {
        if (addonToggle.checked) { add(addonVariant, 1); }
        else { fetch(cfg.changeUrl + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: addonVariant, quantity: 0 }) }).then(function (r){ return r.json(); }).then(renderItems); }
      });
    }
    drawer.querySelectorAll('[data-tab]').forEach(function (tab) {
      tab.addEventListener('click', function () {
        drawer.querySelectorAll('[data-tab]').forEach(function (t) { t.classList.remove('is-active'); });
        tab.classList.add('is-active');
        drawer.querySelectorAll('[data-panel]').forEach(function (p) { p.classList.toggle('is-hidden', p.getAttribute('data-panel') !== tab.getAttribute('data-tab')); });
      });
    });

    window.mieCartAdd = add;
    window.mieCartOpen = open;
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    // Delegated once per card snippet: add the card's variant to the cart and open the drawer.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-card-add]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    var id = btn.getAttribute('data-variant-id');
    if (!id) return;
    if (typeof window.mieCartAdd === 'function') {
      window.mieCartAdd(id, 1);
    } else {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
      }).then(function () {
        if (typeof window.mieCartOpen === 'function') { window.mieCartOpen(); }
        else { window.location.href = '/cart'; }
      });
    }
  });
  } catch(e) { console.error(e); }
})();

})();
